export default function DownloadCtaSection() {
  return (
    <section id="download" className="w-full px-4 md:px-6 py-20 md:py-24 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20golden%20abstract%20background%20with%20soft%20radiant%20glow%20in%20center%2C%20luxurious%20elegant%20atmosphere%2C%20celebration%20party%20feeling%2C%20dark%20background%20with%20golden%20light%20rays%2C%20clean%20modern%20aesthetic&width=1800&height=600&seq=cta-bg-download&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/80 via-background-950/70 to-background-950/80"></div>
      <div className="relative z-10 text-center max-w-3xl mx-auto">
        <h2 className="font-heading font-bold text-2xl md:text-4xl text-white mb-4">
          立即下载BB彩票APP
        </h2>
        <p className="text-white/70 text-sm md:text-base mb-8 leading-relaxed">
          加入500万彩民的选择，开启您的幸运之旅
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#"
            className="inline-flex items-center gap-2.5 px-8 py-4 bg-primary-500 text-white font-semibold rounded-full text-base whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all duration-300 hover:scale-105"
          >
            <i className="ri-android-line text-xl"></i>
            Android版下载
          </a>
          <a
            href="#"
            className="inline-flex items-center gap-2.5 px-8 py-4 bg-white text-foreground-950 font-semibold rounded-full text-base whitespace-nowrap cursor-pointer hover:bg-gray-100 transition-all duration-300 hover:scale-105"
          >
            <i className="ri-apple-line text-xl"></i>
            iOS版下载
          </a>
        </div>
        <div className="flex items-center justify-center gap-6 mt-8 text-white/50 text-xs">
          <div className="flex items-center gap-1.5">
            <i className="ri-shield-check-line text-primary-400"></i>
            <span>安全下载</span>
          </div>
          <div className="flex items-center gap-1.5">
            <i className="ri-smartphone-line text-primary-400"></i>
            <span>兼容全机型</span>
          </div>
          <div className="flex items-center gap-1.5">
            <i className="ri-speed-up-line text-primary-400"></i>
            <span>极速体验</span>
          </div>
        </div>
      </div>
    </section>
  );
}